(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordions"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('faq-topic-navigation')) {
  class FAQTopicNavigation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.addEventListener('click', event => this.navigate(event), options);
      window.addEventListener('hashchange', () => this.updateCurrent(), options);
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(type => {
        document.addEventListener(type, () => this.scheduleRefresh(), options);
      });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.refresh(), { ...options, once: true });
      }
      this.refresh();
    }

    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.refreshFrame);
    }

    scheduleRefresh() {
      cancelAnimationFrame(this.refreshFrame);
      this.refreshFrame = requestAnimationFrame(() => {
        if (this.isConnected) this.refresh();
      });
    }

    refresh() {
      const ownSection = this.closest('[data-faq-section]');
      const list = this.querySelector('.faq-navigation__links');
      const allLink = list?.querySelector('[data-faq-all]');
      if (!ownSection || !allLink) return;

      const scope = this.closest('main') || document;
      const sections = Array.from(scope.querySelectorAll('[data-faq-section]')).filter(section => {
        return !section.closest('[hidden]') && section.querySelector('[data-faq-question]') &&
          section.querySelector('[data-faq-heading]')?.textContent.trim();
      });
      const useSections = this.dataset.navigationSource === 'sections' && sections.length > 1;
      const targets = useSections ? sections : Array.from(ownSection.querySelectorAll('[data-faq-question]'));
      const allTarget = useSections ? sections[0] : ownSection;
      allLink.setAttribute('href', `#${allTarget.id}`);

      const items = targets.map(target => {
        const heading = target.querySelector('[data-faq-heading], .accordion__button-text');
        const label = (target.dataset.faqLabel || heading?.textContent || '').replace(/\s+/g, ' ').trim();
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'faq-navigation__link';
        link.setAttribute('href', `#${target.id}`);
        link.setAttribute('data-faq-link', '');
        link.textContent = label;
        item.append(link);
        return item;
      });
      list.replaceChildren(allLink.parentElement, ...items);
      this.updateCurrent();
    }

    navigate(event) {
      const link = event.target.closest('.faq-navigation__link');
      if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();

      const focusTarget = target.matches('[data-faq-question]') ? target.querySelector('summary') :
        target.querySelector('[data-faq-heading]') || target.querySelector('summary');
      focusTarget?.focus({ preventScroll: true });
      const scrollTarget = focusTarget || target;
      scrollTarget.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      // Native fragment links also keep the destination available to browser history.
      if (location.hash !== `#${id}`) history.pushState(null, '', `#${id}`);
      this.updateCurrent(link);
    }

    updateCurrent(selectedLink) {
      const links = Array.from(this.querySelectorAll('.faq-navigation__link'));
      const current = selectedLink || links.find(link => link.getAttribute('href') === location.hash && !link.hasAttribute('data-faq-all')) ||
        links.find(link => link.hasAttribute('data-faq-all'));
      links.forEach(link => {
        if (link === current) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('faq-topic-navigation', FAQTopicNavigation);
}

  } catch(e) { console.error(e); }
})();
})();
